var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.isFiltersByUsers
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "gg-card",
                    [
                      _c("gg-card-header", [_vm._v(" Filters by Users ")]),
                      _c("gg-card-text", [_c("filters-table")], 1)
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "transition",
        {
          attrs: {
            name: "router-anim",
            "enter-active-class": "animated ".concat(_vm.routerAnimation)
          }
        },
        [!_vm.isFiltersByUsers ? _c("router-view") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }